import { postData } from 'src/api/http.service';
import {
  handleApiError,
  getAPIEndpoints,
  generateUserInfoHeader,
  getDataFromSessionStorage,
} from 'src/utils';
import { GET_ALL_OFFLINE_CLASSROOMS } from './types';
import { ApiCallFailedAction, ApiCallInProgress, ApiCallSuccessAction } from './uistate.action';

const getAllOfflineClassRooms = payload => async dispatch => {
  try {
    dispatch(ApiCallInProgress);
    const response = await postData(
      `${getAPIEndpoints().getAllOfflineClassRooms}`,
      payload,
      generateUserInfoHeader(getDataFromSessionStorage('userRoles'))
    );
    dispatch({ type: GET_ALL_OFFLINE_CLASSROOMS, payload: response?.data?.data ?? [] });
    dispatch(ApiCallSuccessAction({}));
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err)));
  }
};

const createOfflineClassRoom = data => async dispatch => {
  try {
    dispatch(ApiCallInProgress);
    const response = await postData(
      `${getAPIEndpoints().createOfflineClassRoom}`,
      data,
      generateUserInfoHeader(getDataFromSessionStorage('userRoles'))
    );
    return response?.data?.data ?? {};
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err)));
  }
};

export { getAllOfflineClassRooms, createOfflineClassRoom };
